import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import usePermissionUtils from "components/permissionUtils";

import { RouteConfig } from "./index";
// const [updatedRoutesPermit] = usePermissionUtils();
// console.log("Check updatedRoutesPermit", updatedRoutesPermit);

const AppRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState(null);

  useEffect(() => {
    const tokenFromLocalStorage = localStorage.getItem("authToken");
    setToken(tokenFromLocalStorage);
  }, []);

  useEffect(() => {
    if (token && location?.pathname === "/") {
      navigate("/dashboard", { replace: true });
    } else if (location?.pathname === "/") {
      navigate("/auth/signin", { replace: true });
    }
  }, [navigate, location, token]);

  const { routesForAuthenticatedOnly, routesForNotAuthenticatedOnly } =
    RouteConfig();

  return (
    <Routes>
      {routesForAuthenticatedOnly.map((route, index) => (
        <Route key={index} path={route.path} element={route.element}>
          {route.children.map((childRoute, childIndex) => (
            <Route
              key={childIndex}
              path={childRoute.path}
              element={childRoute.element}
            />
          ))}
        </Route>
      ))}

      {routesForNotAuthenticatedOnly.map((route, index) => (
        <Route key={index} path={route.path} element={route.element}>
          {route.children.map((childRoute, childIndex) => (
            <Route
              key={childIndex}
              path={childRoute.path}
              element={childRoute.element}
            />
          ))}
        </Route>
      ))}
    </Routes>
  );
};

export default AppRoutes;
